import {
    Autocomplete,
    AutocompleteOption,
    GroupAutocompleteOptions,
} from "components/Form/components/Autocomplete/Autocomplete";

interface MoveToLocationProps {
    changeValue: (value: string) => void;
    value?: string;
    options: { group: GroupAutocompleteOptions };
    name: string;
    defaultValue?: AutocompleteOption;
    recordLocationId?: string;
}

export const MoveToLocationAutocomplete = ({
    changeValue,
    value,
    options,
    name,
    defaultValue,
    recordLocationId,
}: MoveToLocationProps) => {
    return (
        <Autocomplete
            name={name}
            onChange={changeValue}
            value={value}
            options={options}
            additionalProps={{
                label: "Location",
                isOptionDisabled: (option: any) =>
                    option?.is_readonly || option?.value === recordLocationId,
                showReadOnlyChip: true,
                clearable: false,
                id: "id",
                placeholder: "Select Location",
                required: true,
                fieldWidth: 420,
            }}
            defaultValue={defaultValue}
        />
    );
};
